const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  daUrl: process.env.REACT_APP_DA_URL,
};

export default config;
